var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Legitimierung",
        size: "lg",
        "hide-cancel": "",
        "ok-text": "Bestätigen",
        "ok-disabled": !_vm.dataValid
      },
      on: {
        ok: _vm.upload,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("Upload", {
        attrs: { meta: _vm.meta },
        on: { input: _vm.identificationChanged },
        model: {
          value: _vm.identification,
          callback: function($$v) {
            _vm.identification = $$v
          },
          expression: "identification"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }